import { Link } from "react-router-dom";
import { Axe } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-border bg-card">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-8 px-5 py-14 md:grid-cols-4 lg:px-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 text-primary">
            <Axe className="h-5 w-5" strokeWidth={2.5} />
            <span className="font-head text-lg font-bold text-foreground">HORNSBY</span>
          </div>
          <p className="mt-4 max-w-xs text-sm text-muted-foreground">
            Academically Strong. Prepared for Life. A complete K-12 homeschool curriculum built for families who value grit and grounding.
          </p>
        </div>
        <div>
          <p className="label-caps text-muted-foreground">Learn</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/curriculum" className="text-foreground/80 hover:text-primary">Curriculum</Link></li>
            <li><Link to="/tutor" className="text-foreground/80 hover:text-primary">AI Tutor</Link></li>
            <li><Link to="/pricing" className="text-foreground/80 hover:text-primary">Enrollment</Link></li>
          </ul>
        </div>
        <div>
          <p className="label-caps text-muted-foreground">Account</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/login" className="text-foreground/80 hover:text-primary">Log In</Link></li>
            <li><Link to="/register" className="text-foreground/80 hover:text-primary">Register</Link></li>
            <li><Link to="/dashboard" className="text-foreground/80 hover:text-primary">Members Area</Link></li>
          </ul>
        </div>
        <div>
          <p className="label-caps text-muted-foreground">Hornsby</p>
          <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
            <li>Hornsbyhomeschool.com</li>
            <li><a href="mailto:hello@hornsbyhomeschool.com" className="hover:text-primary" data-testid="footer-email">hello@hornsbyhomeschool.com</a></li>
            <li><a href="tel:+16018905565" className="hover:text-primary" data-testid="footer-phone">601-890-5565</a></li>
            <li data-testid="footer-location">Geneva, AL</li>
            <li>K-12 · 15 subjects · full library</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border px-5 py-5 text-center text-xs text-muted-foreground lg:px-8">
        © {new Date().getFullYear()} Hornsby Homeschool Curriculum. Academically Strong. Prepared for Life.
      </div>
    </footer>
  );
}
